import type { Criteria } from 'bundles/connect/types';
import {
  BUILDING_INFO_FILTER_KEYS,
  PROPERTY_INFO_FILTER_KEYS,
  LOT_INFO_FILTER_KEYS,
  OWNER_INFO_FILTER_KEYS,
  FINANCIAL_INFO_FILTER_KEYS,
  TENANT_INFO_FILTER_KEYS,
  EL_PROPERTY_INFO_FILTER_KEYS,
  INVESTMENT_DETAILS_FILTER_KEYS,
  EL_BUILDING_INFO_FILTER_KEYS,
} from './constants';

export const getNumActiveFiltersByGroup = (criteria: Criteria, exclusiveListing?: boolean) => {
  const filterKeys = exclusiveListing ?
    [
      EL_PROPERTY_INFO_FILTER_KEYS,
      INVESTMENT_DETAILS_FILTER_KEYS,
      EL_BUILDING_INFO_FILTER_KEYS
    ] :
    [
      PROPERTY_INFO_FILTER_KEYS,
      BUILDING_INFO_FILTER_KEYS,
      LOT_INFO_FILTER_KEYS,
      OWNER_INFO_FILTER_KEYS,
      FINANCIAL_INFO_FILTER_KEYS,
      TENANT_INFO_FILTER_KEYS
    ];

  return filterKeys.map((filterGroup) => {
    let count = 0;

    filterGroup.forEach((filterKey) => {
      if (Array.isArray(filterKey)) {
        const values = filterKey.map(k => criteria[k]);
        if (values.some(value => Array.isArray(value) ? value.length > 0 :
          value !== null && value !== undefined && value !== '')
        ) {
          count += 1;
        }
      } else {
        const value = criteria[filterKey];
        if (Array.isArray(value)) {
          count += value.length > 0 ? 1 : 0;
        } else if (value !== null && value !== undefined && value !== '' && value !== false) {
          count += 1;
        }
      }
    });

    return count;
  });
};
